import { Component, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'host-reservation-bar',
  templateUrl: './reservation-bar.component.html',
  styleUrls: ['./reservation-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReservationBarComponent implements OnInit {
  @Input() reservation;
  @Input() isSelected = false;
  @Input() isRelatedSelected = false;
  @Input() cellWidth;
  @Output() onClickReservation = new EventEmitter();
  @Output() onClickChangeHouse = new EventEmitter();
  @Output() onClickExtendStay = new EventEmitter();
  @Output() onClickCreateTask = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }

}
